import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { Amp } from './pages/Amp';
import { Header } from './components/Header';
import { Outlet, useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Layout = () => {
  const {
    pathname
  } = useLocation();
  return /*#__PURE__*/_jsxs("div", {
    ...stylex.props(styles.app),
    children: [/*#__PURE__*/_jsx(Header, {}), /*#__PURE__*/_jsx(Outlet, {}), /*#__PURE__*/_jsx("div", {
      ...stylex.props(pathname !== '/' && styles.hide),
      children: /*#__PURE__*/_jsx(Amp, {})
    })]
  });
};